import { object, number, string, array, record, any, url, enum as _enum } from 'zod'
import { email } from './core'
import { organization } from './organization'

export enum CompanyType {
  Distributor = 'distributor',
  Retailer = 'retailer'
}

export let companyTypeLabels: Record<CompanyType, string> = {
  [CompanyType.Distributor]: 'Дистрибьютор',
  [CompanyType.Retailer]: 'Торговая компания'
}

export let createCompany = object({
  name: string().min(1),
  type: _enum(CompanyType),
  storeName: string().min(1).optional(),
})

export let addCompany = object({
  name: string().min(1),
  loginUrl: url(),
  organization: organization.optional(),
  representatives: array(
    object({
      id: number().optional(),
      email,
      first_name: string().min(1),
      last_name: string().min(1)
    })
  )
    .min(1)
    .superRefine((reps, ctx) => {
      let seen = new Set<string>()
      for (let i = 0; i < reps.length; i++) {
        let email = reps[i].email.toLowerCase()
        if (seen.has(email)) {
          ctx.addIssue({
            code: 'custom',
            message: 'Этот адрес повторяется.',
            path: [i, 'email']
          })
        }
        seen.add(email)
      }
    })
})

export let updateCompany = addCompany
  .extend({
    id: number(),
    organization: organization
  })
  .omit({ representatives: true, loginUrl: true })

export let addCompanyMember = object({
  email,
  first_name: string().min(1),
  last_name: string().min(1),
  permissions: record(string(), any()).optional(),
  company_id: number()
})
